import { render } from "./SwapOrderReceipt.vue?vue&type=template&id=39828739&scoped=true"
import script from "./SwapOrderReceipt.vue?vue&type=script&lang=js"
export * from "./SwapOrderReceipt.vue?vue&type=script&lang=js"

import "./SwapOrderReceipt.vue?vue&type=style&index=0&id=39828739&scoped=true&lang=css"
import "./SwapOrderReceipt.vue?vue&type=style&index=1&id=39828739&scoped=true&lang=css"

import exportComponent from "/home/runner/work/fomofinal/fomofinal/fomoapp/frontend3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39828739"]])

export default __exports__